import { adminConstants } from '../constant/admin-constant';

const initialState = {
    loading: false,
    list: {},
    list_types: {
        result: {
            lists: {
                data: []
            }
        }
    },
};
export function listTypeReducer(state = initialState, action) {

    switch (action.type) {
        case adminConstants.GET_ALL_LIST_TYPES_REQUEST:
            return {
                ...state, loading: true, listTypeData: {}, editListTypeItem: '', storedListTypeItem: '', updatedListTypeItem: '', deleteListItem: false,
            };
        case adminConstants.GET_ALL_LIST_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                list_types_data: action.payload.result.lists.data,
                current_page: action.payload.result.lists.current_page,
                pages: action.payload.result.lists.last_page
            };
        case adminConstants.GET_ALL_LIST_TYPES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // case adminConstants.GET_LIST_REQUEST:
        //     return { ...state, loading: true };
        // case adminConstants.GET_LIST_SUCCESS:
        //     // console.log('from reducer', action.payload.type, action.payload.list.result.list_type.listing);
        //     return { ...state, loading: false, [action.payload.type]: action.payload.list.result };
        // case adminConstants.GET_LIST_FAILURE:
        //     return { ...state, loading: false, error: action.payload };


        case adminConstants.GET_LIST_TYPE_ITEM_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_LIST_TYPE_ITEM_SUCCESS:
            return { ...state, loading: false, listTypeItem: action.payload.result.list_type };
        case adminConstants.GET_LIST_TYPE_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.STORE_LIST_TYPE_ITEM_REQUEST:
            return { ...state, loading: true, editList: '', storedListItem: '' }
        case adminConstants.STORE_LIST_TYPE_ITEM_SUCCESS:
            return { ...state, loading: false, storedListTypeItem: action.payload.list_type };
        case adminConstants.STORE_LIST_TYPE_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.EDIT_LIST_TYPE_ITEM_REQUEST:
            return { ...state, loading: true, updatedListItem: '' };
        case adminConstants.EDIT_LIST_TYPE_ITEM_SUCCESS:
            return { ...state, loading: false, updatedListItem: action.payload.list };
        case adminConstants.EDIT_LIST_TYPE_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_LIST_TYPE_REQUEST:
            return { ...state, loading: true, deleteListItem: false }
        case adminConstants.DELETE_LIST_TYPE_SUCCESS:
            return { ...state, loading: false, deleteListItem: true };
        case adminConstants.DELETE_LIST_TYPE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ListType.jsx